"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactForm = require("react-form");

var _Button = _interopRequireDefault(require("../Button"));

var ResetButton = function ResetButton(props) {
  var _useFormContext = (0, _reactForm.useFormContext)(),
      reset = _useFormContext.reset;

  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
    onClick: reset
  }));
};

ResetButton.propTypes = {
  formContext: _propTypes.default.object
};
var _default = ResetButton;
exports.default = _default;